import { useEffect, useState } from "react";

interface SelectOption {
  text: string;
  value: string;
}

type Option = {
  value: string;
  text: string;
}

interface SelectProps {
  defaultValue: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  label?: string;
  name:string;
}

export default function SelectInput({
  options,
  onChange,
  defaultValue,
  label,
  name,
  ...props
}: SelectProps ) {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedValue(value);
    onChange(value);
  };

  function removeDefaultOption(options: Option[], defaultValue: string): Option[] {
    return options.reduce((filtered: any, option: any) => {
      if (option.value !== defaultValue) {
        filtered.push(option);
      }
      return filtered;
    }, []);
  }
  
  const filteredOptions = removeDefaultOption(options, defaultValue);



  return (
   // <div className="relative w-full min-w-[200px] h-11">
   <div>
    <p className="text-[10px] font-medium text-blue-gray-300 ">{label}</p>
    <select
      className="form-control w-full bg-transparent px-2 py-3 text-blue-gray-700 font-sans font-normal outline outline-0 focus:outline-0 border-1 
       disabled:bg-blue-gray-50 disabled:border-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 border text-sm px-3 py-3 rounded-md border-blue-gray-200
      focus:border-2 focus:border-gray-900 bg-gray-100 flex items-center text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
      aria-label={label ? label : "Select"}
      // placeholder={label}
      defaultValue={defaultValue}
      onChange={handleChange}
      value={selectedValue}
      {...props}
    >
      <option value="">{ defaultValue || label || ""}</option>
      {filteredOptions.map(({ value, text }) => (
        <option value={value} key={`select_${value}`}>
          {text}
        </option>
      ))}
    </select>
   </div>
  );
}

// import React, { useState, useEffect } from "react";
// import { Select, Option } from "@material-tailwind/react";

// interface SelectOption {
//   text: string;
//   value: string;
// }

// interface SelectProps {
//   defaultValue: string;
//   options: SelectOption[];
//   onChange: (value: string) => void;
//   label: string;
//   name?: string;
// }

// export default function SelectInput({
//   options,
//   onChange,
//   defaultValue,
//   label,
//   name,
// }: SelectProps) {
//   const [selectedValue, setSelectedValue] = useState<string>("");

//   useEffect(() => {
//     const selectedOption = options.find(opt => opt.value === defaultValue);
//     console.log("selected option",selectedOption)
//     if (selectedOption) {
//       setSelectedValue(selectedOption.text); // Set the visible label
//     }
//   }, [defaultValue, options]);

//   const handleChange = (selectedText: string | undefined) => {
//     const found = options.find(opt => opt.text === selectedText);
//     if (found) {
//       setSelectedValue(selectedText ?? ""); // ✅ Fix: Fallback for undefined
//       onChange(found.value);
//     }
//   };

//   return (
//     <div className="w-full">
//       <Select
//         label={label}
//         value="94494327-c0c0-11ec-85d6-b0227ad7fa24"
//         onChange={handleChange}
//         name={name}
//         className="w-full"
//       >
//         {options.map(({ value, text }) => (
//           <Option key={value} value={value}>
//             {text}
//           </Option>
//         ))}
//       </Select>
//     </div>
//   );
// }

// import React, { useEffect, useState } from "react";

// interface SelectOption {
//   text: string;
//   value: string;
// }

// interface SelectProps {
//   defaultValue: string;
//   options: SelectOption[];
//   onChange: (value: string) => void;
//   label: string;
//   name?: string;
// }

// export default function SelectInput({
//   options,
//   onChange,
//   defaultValue,
//   label,
//   name,
// }: SelectProps) {
//   const [selectedValue, setSelectedValue] = useState(defaultValue);
//   console.log("Selected value", selectedValue)

//   useEffect(() => {
//     setSelectedValue(defaultValue);
//   }, [defaultValue]);

//   const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const value = e.target.value;
//     setSelectedValue(value);
//     onChange(value);
//   };

//   return (
//     <div className="w-full">
//       <label className="block text-sm font-medium text-gray-700 mb-1">
//         {label}
//       </label>
//       <select
//           name={name}
//           id={name}
//           value={selectedValue}
//           onChange={handleChange}
//           className="peer block w-full appearance-none rounded-md border border-gray-300 bg-white px-3 py-2 pr-10 text-sm text-gray-900 shadow-sm transition focus:border-grey-900 focus:outline-none focus:ring-1 focus:ring-grey-600"
//         >
//           <option value="" disabled>
//             {defaultValue}
//           </option>
//           {options.map(({ value, text }) => (
//             <option key={value} value={value}>
//               {text}
//             </option>
//           ))}
//         </select>
//         <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-500">
//           <svg
//             className="h-4 w-4"
//             viewBox="0 0 20 20"
//             fill="currentColor"
//           >
//             <path
//               fillRule="evenodd"
//               d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z"
//               clipRule="evenodd"
//             />
//           </svg>
//         </div>
//       </div>
//   );
// }

// import { ChangeEvent, SelectHTMLAttributes } from "react";

// interface SelectOption {
//   text: string;
//   value: string;
// }

// interface SelectProps {
//   defaultValue: string;
//   options: SelectOption[];
//   onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
//   label?: string;
// }

// export default function Select({
//   options,
//   onChange,
//   defaultValue,
//   label,
//   ...props
// }: SelectProps & SelectHTMLAttributes<HTMLSelectElement>) {
//   return (
//     <select
//       className="form-control w-100"
//       aria-label={label ? label : "Select"}
//       defaultValue={defaultValue}
//       onChange={onChange}
//       {...props}
//     >
//       <option value="">{defaultValue}</option>
//       {options.map(({ value, text }) => (
//         <option value={value} key={`select_${value}`}>
//           {text}
//         </option>
//       ))}
//     </select>
//   );
// }